export const CLEAR_VALIDATION_STATE = 'ClearValidationState';
export const ADD_VALIDATION_FAILURE = 'AddValidationFailure';
export const REMOVE_VALIDATION_FAILURE = 'RemoveValidationFailure';
export const SET_VALIDATION_TRIGGER = 'SetValidationTrigger';
export const SET_VALIDATION_TRIGGER_SUPPRESS_MESSAGES =
	'SetValidationSuppressMessages';
